import { ComponentPropsWithRef, KeyboardEvent, MouseEvent } from "react";
import styled, { css } from "styled-components";
import { primary03, shade0, shade100, shade700 } from "../../styles/tokens";

// TEXT

// STYLES
export const A = styled.a.attrs<AProps>(
  ({ $disabled, tabIndex, onClick, onKeyDown }) => ({
    tabIndex: tabIndex || 0,
    "aria-disabled": $disabled || undefined,
    onClick: $disabled
      ? (e: MouseEvent<HTMLAnchorElement>) => e.preventDefault()
      : onClick,
    onKeyDown: (e: KeyboardEvent<HTMLAnchorElement>) => {
      if (e.key === " " && !$disabled) {
        e.preventDefault();
        e.currentTarget.click();
      }
      onKeyDown?.(e);
    },
  }),
)<AProps>`
  cursor: pointer;
  position: relative;
  justify-content: center;
  text-decoration: none;
  align-items: center;
  gap: 0.5rem;
  color: ${shade0};

  &[aria-disabled="true"] {
    pointer-events: none;
    color: ${shade700};
  }

  &:focus-visible:not([aria-disabled="true"]) {
    outline: 0.0625rem solid ${shade0};
    padding: 0 0.625rem;
    margin: 0 -0.625rem;
  }

  &:hover:not([aria-disabled="true"]) {
    color: ${primary03};
  }

  &:active {
    color: ${shade100};
  }

  ${({ $type }) => {
    if ($type === "default")
      return css`
        &:hover:not([aria-disabled="true"]) {
          color: ${shade0};
        }

        &::after {
          left: 0;
          content: "";
          width: 100%;
          bottom: -0.125rem;
          height: 0.0625rem;
          position: absolute;
          transform: scaleX(0);
          transform-origin: left;
          transition: transform 0.2s;

          background-color: ${shade0};
        }

        &:hover::after {
          transform: scaleX(1);
        }
      `;
  }}
`;

// DATA

// TYPES
interface AProps extends ComponentPropsWithRef<"a"> {
  $disabled?: boolean;
  $type?: "default" | "colour" | "underlined";
}

// CONSTANTS

// FUNCTIONS

// ASSETS
